<template>
  <BCard class="review">
    <div class="review__donations-details-box d-flex flex-row">
      <div class="d-flex flex-row w-100">
        <div class="justify-content-around">
          <div class="p-5">
            <div class="review__donations-details">
              <button
                :class="{
                  'review__donations-details-status-buttons': true,
                  'awaiting_approval': true,
                  'review__donations-details-status-buttons-highlighted': selectedStatus == 'waiting'
                }"
                @click="addWaiting">
                <svg-icon :fa-icon="faCircle"/>
              </button>
              <button
                :class="{
                  'review__donations-details-status-buttons': true,
                  'approved': true,
                  'review__donations-details-status-buttons-highlighted': selectedStatus == 'approved'
                }"
                @click="addApproved">
                <svg-icon :fa-icon="faCheck"/>
              </button>
              <button
                :class="{
                  'review__donations-details-status-buttons': true,
                  'denied': true,
                  'review__donations-details-status-buttons-highlighted': selectedStatus == 'denied'
                }"
                @click="addDenied">
                <svg-icon :fa-icon="faXmark"/>
              </button>
              <button
                :class="{
                  'review__donations-details-status-buttons': true,
                  'mailed': true,
                  'review__donations-details-status-buttons-highlighted': selectedStatus == 'mailed'
                }"
                @click="addMailed">
                <svg-icon :fa-icon="faEnvelope"/>
              </button>
              <button
                :class="{
                  'review__donations-details-status-buttons': true,
                  'archived': true,
                  'review__donations-details-status-buttons-highlighted': selectedStatus == 'archived'
                }"
                @click="addArchived">
                <svg-icon :fa-icon="faArchive"/>
              </button>
              <div class="">
                <label>
                  Type of Event
                </label>
                <b-form-select
                  class="actions__action-box-select-status details-select mt-0 mb-3 "
                  :options="eventTypeOptions"
                  v-model="formObject.eventType"
                  @change="onRowUpdated"/>
                <label>
                  Type of Award
                </label>
                <b-form-select
                  class="actions__action-box-select-status details-select mt-0 mb-3"
                  :options="awardTypeOptions"
                  v-model="formObject.awardType"
                  @change="onRowUpdated"/>
                <label>
                  Number of Awards
                </label>
                <input
                  class="form-control details-input"
                  v-model="formObject.awardCount"
                  @input="onRowUpdated"
                  type="number"
                  min="0"
                  max="1000000"/>
                <div v-if="showDeniedMessage" class="mt-3">
                  <label>
                    Rejection Message
                  </label>
                  <BFormTextarea
                    rows="6"
                    v-model="formObject.deniedMessage"
                    @input="onRowUpdated"
                    class="details-textarea">
                  </BFormTextarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="flex-column w-75">
          <div class=" pr-5 pl-5 pt-5 pb-2">
            <h4 class="text-brown review__donations-details-title">Organization Information</h4>
            <p class="text-tan review__donations-details-text">{{ rowData.organization }}</p>
            <p class="text-tan review__donations-details-text">{{ orgType }}</p>
            <p class="text-tan review__donations-details-text">{{ rowData.organizationEin }}</p>
            
            <div v-if="editingAddress">
              <b-form-group class="col-xs-12">
                <h5 class="text-brown">Address 1</h5>
                <b-form-input v-model="editAddressObject.address1"  trim></b-form-input>
              </b-form-group>

              <b-form-group>
                <h5 class="text-brown">Address 2</h5>
                <b-form-input v-model="editAddressObject.address2"  trim></b-form-input>
              </b-form-group>

              <div class="form-row">
                <b-form-group :class="{'col-xs-6': true}">
                  <h5 class="text-brown">Country</h5>
                  <b-form-select
                    v-model="editAddressObject.country"
                    @input="onCountryChanged">
                    <option
                      v-for="country in countryList"
                      :key="country.id"
                      :value="country.countryCode"
                      class="org-details__type-options">
                      {{ country.countryName }}
                    </option>
                  </b-form-select>
                </b-form-group>

                <b-form-group :class="{'col-xs-6': true}">
                  <h5 class="text-brown">State</h5>
                  <b-form-select
                    v-model="editAddressObject.state">
                    <option
                      v-for="state in availableStates"
                      :key="state.id"
                      :value="state.abbreviation"
                      class="org-details__type-options">
                      {{ state.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </div>

              <b-form-group>
                <h5 class="text-brown">City</h5>
                <b-form-input v-model="editAddressObject.city"  trim></b-form-input>
              </b-form-group>

              <b-form-group>
                <h5 class="text-brown">Zip</h5>
                <b-form-input v-model="editAddressObject.zip"  trim></b-form-input>
              </b-form-group>

              <error-list v-if="hasErrors">
                <template slot="header">
                  <h5>There was an issue with the form submission.</h5>
                </template>
                <template slot="content">
                  <ul>
                    <li v-for="error in this.generalErrors">{{ error }}</li>
                  </ul>
                </template>
              </error-list>

              <b-form-group>
                <b-button class="btn-spacing" @click="closeEditAddressForm">Cancel</b-button>
                <b-button @click="onSubmit" variant="primary">Save</b-button>
              </b-form-group>
            </div>
            <div v-else>
              <p class="text-tan review__donations-details-text" v-html="rowData.organizationAddress"/>
              <p class="text-tan review__donations-details-text" v-html="rowData.organizationAddress2"/>
              <p class="text-tan review__donations-details-text" v-html="rowData.organizationCity + ' ' + rowData.organizationState + ' ' + rowData.organizationZip"/>
              <a @click="openEditAddressForm" class="review__donations-details-link">Edit Address</a>
            </div>

          </div>
          <div class=" pr-5 pl-5 pb-2">
            <h4 class="text-brown review__donations-details-title">Event Information</h4>
            <p class="text-tan review__donations-details-text">
              Event Type: {{ rowData.eventType }}
            </p>
            <p v-if="rowData.award" class="text-tan review__donations-details-text">
              Donation Type: {{ rowData.award.award_type.name }}
              - ${{ $filters.formatNumber(rowData.award.award_type.price_in_dollars) }}
              <span style="text-transform:none;">x</span>{{ $filters.formatNumber(rowData.award.award_amount) }}
            </p>
            <p v-else class="text-tan review__donations-details-text">No Award Assigned
            </p>
            <p class="text-tan review__donations-details-text">Donation Total:
              $<span v-if="rowData.award">{{ $filters.formatNumber(rowData.award.award_amount * rowData.award.award_type.price_in_dollars) }}</span>
              <span v-else>0</span>
            </p>
            <p class="text-tan review__donations-details-text">Attendees: {{ rowData.eventAttendees }}</p>
            <p class="text-tan review__donations-details-text">Event Date: {{ $filters.formatDate(rowData.eventDate) }}</p>
          </div>
          <div class=" pr-5 pl-5 pb-2">
            <h4 class="text-brown review__donations-details-title">Contact Information</h4>
            <p class="text-tan review__donations-details-text">{{ rowData.applicantName }}</p>
            <p class="text-tan review__donations-details-text">{{ rowData.applicantPhone }}</p>
            <p class="text-tan review__donations-details-text">{{ rowData.applicantEmail }}</p>
          </div>
        </div>

        <div class="flex-column w-100">
          <div class=" p-5 ">
            <h4 class="text-brown review__donations-details-title">Event Description</h4>
            <p class="text-tan ">{{ rowData.eventDescription }}</p>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="addressModal"
      class="address-modal"
      title="Suggested Address"
      hide-footer>
      <div class="address-modal-inner">
        <p class="address-modal-bold text-danger">
          <img
          src="/images/icon-error.png"
          class="address-modal-invalid"> Invalid Address
        </p>
        <p class="address-modal-fineprint text-danger">
          This address didn’t match up in our system.
        </p>
        <p class="address-modal-text text-danger">
          {{ editAddressObject.address1 }}<span v-if="editAddressObject.address2"> {{ editAddressObject.address2 }}</span> {{ editAddressObject.city }} {{ editAddressObject.state }} {{ editAddressObject.zip}}
        </p>

        <p class="address-modal-fineprint text-danger">
          Below is a suggested address.
        </p>
        <p class="address-modal-text text-brown">
          {{ suggestedAddress.Address1 }}<span v-if="suggestedAddress.Address2"> {{ suggestedAddress.Address2 }}</span> {{ suggestedAddress.City }} {{ suggestedAddress.State }} {{ suggestedAddress.Zip5 }}
        </p>
        <button
          class="btn btn-primary btn-modal"
          @click="useThisAddress(suggestedAddress)">Use This Address
        </button>


        <p class="address-modal-fineprint text-brown">Don't see a correct address?</p>
        <div class="address-modal-bottom">
          <button
          class="btn btn-secondary btn-modal"
          @click="hideModal">Re-Enter This Address</button>
        </div>
      </div>
    </b-modal>
  </BCard>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue';
  
  // Import components
  import ErrorList from '../errorList.vue';

  // Import Icons
  import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
  import { faCircle } from '@fortawesome/free-solid-svg-icons';
  import { faArchive } from '@fortawesome/free-solid-svg-icons';
  import { faCheck } from '@fortawesome/free-solid-svg-icons';
  import { faXmark } from '@fortawesome/free-solid-svg-icons';  

  const props = defineProps([
    'rowData', 
    'awardTypes',
    'organizationTypes',
    'states'
  ]);

  const selectedStatus = ref('');

  const formObject = ref({
    id: '',
    eventType: '',
    awardType: '',
    awardCount: 0,
    deniedMessage: ''          
  });
  
  const emit = defineEmits([
    'RowUpdated',
    'addWaiting',
    'addApproved',
    'addDenied',
    'addMailed',
    'addArchived'
  ]);

  const showDeniedMessage = computed(() => {
    if (selectedStatus.value == 'denied') return true

    if (formObject.deniedMessage != null && selectedStatus.value == '') return true

    return false
  });

  const orgType = computed (() => {
    if (_.has(props.organizationTypes, props.rowData.organizationType)) {
      return props.organizationTypes[props.rowData.organizationType]
    }
    return props.rowData.organizationType
  });

  function onRowUpdated() {
    emit('rowUpdated', formObject.value)
  }

  function addWaiting() {
    selectedStatus.value = 'waiting'
    emit('addWaiting')
  }

  function addApproved() {
    selectedStatus.value = 'approved'
    emit('addApproved')
  }

  function addDenied() {
    selectedStatus.value = 'denied'
    emit('addDenied')
  }

  function addMailed() {
    selectedStatus.value = 'mailed'
    emit('addMailed')
  }

  function addArchived() {
    selectedStatus.value = 'archived'
    emit('addArchived')
  }

  onMounted(() => {
    formObject.value.id = props.rowData.id
    formObject.value.eventType = props.rowData.eventType
    formObject.value.deniedMessage = props.rowData.deniedMessage
    if (props.rowData.award) {
      formObject.value.awardType = props.rowData.award.award_type.slug
      formObject.value.awardCount = props.rowData.award.award_amount
    } else {
      formObject.value.awardType = ''
      formObject.value.awardCount = 0
    }
  });
</script>

<script>
  import * as moment from 'moment';
  import _ from 'lodash'

  export default {
    mounted() {
    },
    data() {
      return {
        editAddressObject: {
          address1: '',
          address2: '',
          country: '',
          city: '',
          state: '',
          zip: ''
        },
        eventTypeOptions: [
          { value: 'do_nothing', text: 'Update Event Type' },
          { value: 'Raffle', text: 'Raffle' },
          { value: 'Silent Auction', text: 'Silent Auction' },
          { value: 'Other', text: 'Other' }
        ],
        awardTypeOptions: [
          { value: 'do_nothing', text: 'Type of Donation' },
          { value: 'entree-chips-queso', text: 'Two Entrees, Chips & Queso Card(s)' },          
          { value: 'dinner-for-two', text: 'Dinner for Two Card(s)' },
          { value: 'burrito-bucks', text: 'Burrito Buck(s)' },
          { value: 'free-chips-and-guac', text: 'Free Chips & Guac Card(s)' },
          { value: 'bogo', text: 'BOGO Card(s)' },
          { value: 'free-kids-meal', text: 'Free Kids Meal Card(s)' }         
        ],
        updatingToOther: [],
        eventType: "do_nothing",
        otherType: "do_nothing",
        editingAddress: false,
        countryList: [
          { id: 1, countryCode: 'US', countryName: 'United States' },
          { id: 2, countryCode: 'CA', countryName: 'Canada' }
        ],
        availableStates: [],
        hasErrors: false,
        generalErrors: [],
        suggestedAddress: {}
      }
    },

    computed: {
    },

    methods: {
      initiateAddressForm() {
        this.editAddressObject = {
          donationId: this.rowData.id,
          address1: this.rowData.organizationAddress,
          address2: this.rowData.organizationAddress2,
          country: this.rowData.organizationCountry,
          city: this.rowData.organizationCity,
          state: this.rowData.organizationState,
          zip: this.rowData.organizationZip
        }
      },

      openEditAddressForm() {
        this.initiateAddressForm()
        this.filterAvailableStates()
        this.editingAddress = true
      },

      closeEditAddressForm() {
        this.editingAddress = false;
        this.generalErrors = []
        this.hasErrors = false
      },

      onCountryChanged() {
        this.filterAvailableStates()
      },

      filterAvailableStates() {
        let country =
          this.editAddressObject.country === '' ? 'US' : this.editAddressObject.country

        if (Array.isArray(this.states)) {
          this.availableStates = this.states.filter(
            state => state.code === country
          )
        }
      },

      onSubmit() {

        this.validateAddress()

      },

      validateAddress() {
        this.generalErrors = []
        this.hasErrors = false

        axios.post('/donations/ajax/verify-address', this.editAddressObject)
          .then(response => {
            if (response.data.valid_address.match) {
              this.saveAddressForm()
            } else {
              this.suggestedAddress = response.data.valid_address
              this.showModal()
            }

          })
          .catch(e => {
            this.handleError(e)
          })
      },

      useThisAddress(newAddress) {
        this.editAddressObject.address1 = newAddress.Address1
        this.editAddressObject.address2 = newAddress.Address2
        this.editAddressObject.city = newAddress.City
        this.editAddressObject.state = newAddress.State.toUpperCase()
        this.editAddressObject.zip = newAddress.Zip5
        this.hideModal()
        this.saveAddressForm()
      },

      saveAddressForm() {
        this.generalErrors = []
        this.hasErrors = false
        axios.post('/donations/ajax/application-address', this.editAddressObject)
          .then(response => {
            this.updateCurrentAddress(this.editAddressObject)
            this.closeEditAddressForm()
          })
          .catch(e => {
            this.handleError(e)
          })
      },

      updateCurrentAddress(newAddress) {
        this.rowData.organizationAddress = newAddress.address1
        this.rowData.organizationAddress2 = newAddress.address2
        this.rowData.organizationCountry = newAddress.country
        this.rowData.organizationCity = newAddress.city
        this.rowData.organizationState = newAddress.state
        this.rowData.organizationZip = newAddress.zip
      },

      handleError(e) {
        // If not error message for some reason...
        if (!e.response) {
          this.hasErrors = true
          this.generalErrors.push(
            "We're sorry, but it looks like there was a network error. Please try again later."
          )
        } else if (e.response.data.errors) {
          this.hasErrors = true
          for (var key in e.response.data.errors) {
            this.generalErrors.push(e.response.data.errors[key][0])
          }
        } else {
          this.hasErrors = true
          this.generalErrors.push(
            "We're sorry, but it looks like there was a network error. Please try again later. "
          )
        }
      },

      showModal() {
        this.$refs.addressModal.show()
      },

      hideModal() {
        this.$refs.addressModal.hide()
      }
    },

    filters: {

    }
  }
</script>
